import { render, staticRenderFns } from "./TickerSearchResultCard.vue?vue&type=template&id=ea63cc94"
import script from "./TickerSearchResultCard.vue?vue&type=script&lang=js"
export * from "./TickerSearchResultCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/skade-pwa/components/ui/atom/Img.vue').default,Truncate: require('/skade-pwa/components/ui/atom/Truncate.vue').default,ChangePercent: require('/skade-pwa/components/ui/atom/ChangePercent.vue').default})
